/**
 * Norwegian language file.
 */
import * as app from './app.json';
import * as error from './error.json';
import * as invoice from './invoice.json';
import * as user from './user.json';
import * as tag from './tag.json';
import * as constant from './constant.json';

export default {
  app,
  error,
  invoice,
  user,
  tag,
  constant,
};



// WEBPACK FOOTER //
// ./src/locale/no/index.js